"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("firebase/storage");

var firebase = require('firebase/app');

var _default = {
  methods: {
    uploadFileToStorage: function () {
      var _uploadFileToStorage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(file, savePath) {
        var fileURL, storageRef;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // console.log('uploadFileToStorage[start] - ' + savePath)
                fileURL = null;
                storageRef = firebase.storage().ref().child(savePath);
                _context2.next = 4;
                return storageRef.put(file).then(
                /*#__PURE__*/
                function () {
                  var _ref = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee(snapshot) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return snapshot.ref.getDownloadURL().then(function (downloadURL) {
                              console.log('uploadFileToStorage[url] - ' + downloadURL);
                              fileURL = downloadURL;
                            }, function (error) {
                              console.log(error);
                            });

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }(), function (error) {
                  console.log(error);
                });

              case 4:
                return _context2.abrupt("return", fileURL);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function uploadFileToStorage(_x, _x2) {
        return _uploadFileToStorage.apply(this, arguments);
      }

      return uploadFileToStorage;
    }(),
    deleteFileFromStorage: function () {
      var _deleteFileFromStorage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(savePath) {
        var isDeleted, storageRef;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // console.log('deleteFileFromStorage[start] - ' + savePath)
                isDeleted = false;
                storageRef = firebase.storage().ref().child(savePath);
                _context4.next = 4;
                return storageRef.delete().then(
                /*#__PURE__*/
                (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          // console.log('deleteFileFromStorage[success]')
                          isDeleted = true;

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), function (error) {
                  console.log(error);
                });

              case 4:
                return _context4.abrupt("return", isDeleted);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function deleteFileFromStorage(_x4) {
        return _deleteFileFromStorage.apply(this, arguments);
      }

      return deleteFileFromStorage;
    }()
  }
};
exports.default = _default;